/**
 * Compare two sets. Comparison is done with shallow equality.
 */
export function compareSets<T>(setA: Set<T>, setB: Set<T>): boolean {
  // Two sets A and B are equal if both sets are the same size
  // and for every element a in setA, there exists an
  // element b in setB such that a = b.
  return setA.size === setB.size && Array.from(setA).every(a => setB.has(a))
}
